var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "modal-add-staff",
      "title": "選擇員工",
      "body-class": "modal-height",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn() {
        return [_c('div', {
          staticClass: "w-100 d-flex"
        }, [_c('div', {
          staticClass: "pagination mr-auto d-flex align-items-center"
        }, [_c('a', {
          staticClass: "mr-2 arrow-point",
          on: {
            "click": function click($event) {
              return _vm.navigateToPage(1);
            }
          }
        }, [_c('IconNavigateToFirst', {
          attrs: {
            "fill": _vm.currentPageNumber === 1 ? '#ccc' : 'black'
          }
        })], 1), _c('a', {
          staticClass: "mr-2 arrow-point",
          on: {
            "click": function click($event) {
              return _vm.navigateToPage(_vm.currentPageNumber - 1);
            }
          }
        }, [_c('IconAngleLeft', {
          attrs: {
            "fill": _vm.currentPageNumber === 1 ? '#ccc' : 'black'
          }
        })], 1), _c('span', {
          staticClass: "mr-2 d-inline-block page-number",
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.navigateToPage(_vm.currentPageNumber);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.currentPageNumber) + " / " + _vm._s(_vm.totalPages) + " ")]), _c('a', {
          staticClass: "mr-2 arrow-point",
          on: {
            "click": function click($event) {
              return _vm.navigateToPage(_vm.currentPageNumber + 1);
            }
          }
        }, [_c('IconAngleRight', {
          attrs: {
            "fill": _vm.currentPageNumber === _vm.totalPages ? '#ccc' : 'black'
          }
        })], 1), _c('a', {
          staticClass: "arrow-point",
          on: {
            "click": function click($event) {
              return _vm.navigateToPage(_vm.totalPages);
            }
          }
        }, [_c('IconNavigateToLast', {
          attrs: {
            "fill": _vm.currentPageNumber === _vm.totalPages ? '#ccc' : 'black'
          }
        })], 1)]), _c('b-button', {
          staticClass: "mr-2 ml-3",
          attrs: {
            "variant": "danger",
            "size": "sm"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_vm._v(" 取消 ")]), _c('b-button', {
          attrs: {
            "variant": "primary",
            "size": "sm"
          },
          on: {
            "click": _vm.submitSelection
          }
        }, [_vm._v(" 確定 ")])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c('b-input-group', {
    staticClass: "mb-3"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "請輸入姓名或員工編號"
    },
    on: {
      "input": _vm.handleStaffKeywordIsChanged
    },
    model: {
      value: _vm.staffKeyword,
      callback: function callback($$v) {
        _vm.staffKeyword = $$v;
      },
      expression: "staffKeyword"
    }
  }), _c('b-input-group-append', [_c('b-button', [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1), _vm.isLoading ? _c('div', {
    staticClass: "text-center mb-3 loading-spinner"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "secondary",
      "small": ""
    }
  })], 1) : _vm._e(), _vm.paginatedStaffs.length > 0 && !_vm.isLoading ? _c('div', {
    staticClass: "scrolling"
  }, _vm._l(_vm.paginatedStaffs, function (staff) {
    return _c('div', {
      key: staff.id
    }, [_c('div', {
      staticClass: "d-flex align-items-center p-2 staff-info",
      on: {
        "click": function click($event) {
          return _vm.handleSelected(staff);
        }
      }
    }, [_c('b-avatar', {
      staticClass: "mr-2",
      attrs: {
        "src": staff.avatar_url
      }
    }), _c('div', {
      staticClass: "\n            mr-auto\n            font-weight-bold\n            text-nowrap text-truncate\n          "
    }, [_vm._v(" " + _vm._s(staff.name)), _c('br'), _c('span', {
      staticClass: "staff-list-info"
    }, [_vm._v(" " + _vm._s(_vm.displayStaffInfo(staff)) + " ")])])], 1)]);
  }), 0) : _vm._e(), _vm.selectedStaff ? _c('div', {
    staticClass: "d-flex align-items-center pt-3",
    staticStyle: {
      "border-top": "1px solid #ddd"
    }
  }, [_c('b-avatar', {
    staticClass: "mr-2",
    attrs: {
      "src": _vm.selectedStaff.avatar_url
    }
  }), _c('div', {
    staticClass: "\n        mr-auto\n        font-weight-bold\n        text-nowrap text-truncate\n        flex-fill\n      "
  }, [_vm._v(" " + _vm._s(_vm.selectedStaff.name)), _c('br'), _c('span', {
    staticClass: "staff-list-info"
  }, [_vm._v(" " + _vm._s(_vm.displayStaffInfo(_vm.selectedStaff)) + " ")])]), _c('b-button', {
    staticClass: "p-1 mr-2",
    attrs: {
      "size": "xs",
      "pill": "",
      "variant": "danger"
    },
    on: {
      "click": _vm.cancelSelected
    }
  }, [_c('i', {
    staticClass: "fa fa-times m-0"
  })])], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }